import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Badge } from "@/components/ui/badge";
import { CalendarClock, Umbrella, Users, AlertCircle } from "lucide-react";
import { CancellationPolicy } from "@/types";

interface CancellationPolicyProps {
  policy: CancellationPolicy;
}

const convertToTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

const Cancellation: React.FC<CancellationPolicyProps> = ({ policy }) => {
  return (
    <div className="w-full">
      <div className="space-y-6">
        <p className="text-sm text-neutral-600 font-[325] leading-[23px]">
          {policy.description}
        </p>
        <div className="space-y-2">
          {policy.refundEligibility.map((eligibility, index) => (
            <div
              key={index}
              className="flex flex-row justify-between items-center gap-2 pl-1"
            >
              <span className="w-1/2 text-sm text-neutral-600 font-[325] leading-[23px]">
                {eligibility.dayRangeMax
                  ? `${eligibility.dayRangeMin}-${eligibility.dayRangeMax} days before departure`
                  : `${eligibility.dayRangeMin}+ days before departure`}
              </span>
              <Badge
                className={`w-1/3 h-7 rounded-md ${
                  eligibility.percentageRefundable === 100
                    ? "bg-emerald-100 text-emerald-600 hover:bg-emerald-100"
                    : "bg-rose-100 text-rose-600 hover:bg-rose-100"
                }`}
              >
                {eligibility.percentageRefundable}% Refund
              </Badge>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Cancellation;
